<template>
  <v-form
      ref="form"
      lazy-validation
      v-model="formValid"
      v-if="item != null"
  >
    <v-alert :value="formError" color="error" class="pb-2">{{ formError }}</v-alert>

    <v-text-field
        v-model="item.name"
        :label="$t('name')"
        :rules="[v => !!v || $t('name_required')]"
        required
        :disabled="formSaving"
        outlined
        dense
    />

    <v-alert
        type="info"
        text
        dense
        class="mb-3"
    >
      {{ $t('workflowFormDefinitionHelp') }}
    </v-alert>

    <v-textarea
        v-model="item.definition"
        :label="$t('workflowDefinition')"
        :placeholder="placeholder"
        outlined
        dense
        rows="14"
        :rules="[validateDefinition]"
        :disabled="formSaving"
        spellcheck="false"
        style="font-family: 'Commit Mono', ui-monospace, monospace;"
    />

    <v-autocomplete
        :value="null"
        :items="templates"
        item-value="id"
        item-text="name"
        :label="$t('workflowInsertNode')"
        outlined
        dense
        clearable
        @change="insertNodeForTemplate"
        :disabled="formSaving"
    />
  </v-form>
</template>
<script>
import axios from 'axios';
import ItemFormBase from '@/components/ItemFormBase';

export default {
  mixins: [ItemFormBase],

  data() {
    return {
      templates: [],
    };
  },

  computed: {
    placeholder() {
      return '{\n  "nodes": [\n    { "id": "build", "template_id": 1 },\n    { "id": "deploy", "template_id": 2 }\n  ],\n  "edges": [\n    { "from": "build", "to": "deploy", "kind": "on_success" }\n  ]\n}';
    },
  },

  async created() {
    try {
      const { data } = await axios.get(`/api/project/${this.projectId}/templates`);
      this.templates = Array.isArray(data) ? data : [];
    } catch (e) {
      this.templates = [];
    }
  },

  methods: {
    getNewItem() {
      return { name: '', definition: '{"nodes":[],"edges":[]}' };
    },
    getItemsUrl() {
      return `/api/project/${this.projectId}/workflow_templates`;
    },
    getSingleItemUrl() {
      return `/api/project/${this.projectId}/workflow_templates/${this.itemId}`;
    },
    validateDefinition(v) {
      if (!v) return true;
      try {
        const parsed = JSON.parse(v);
        if (!parsed || typeof parsed !== 'object') return this.$t('workflowDefinitionInvalid');
        if (!Array.isArray(parsed.nodes)) return this.$t('workflowDefinitionInvalid');
        if (!Array.isArray(parsed.edges)) return this.$t('workflowDefinitionInvalid');
        return true;
      } catch (e) {
        return e.message;
      }
    },
    insertNodeForTemplate(templateId) {
      if (!templateId) return;
      let def;
      try {
        def = JSON.parse(this.item.definition || '{"nodes":[],"edges":[]}');
      } catch (e) {
        def = { nodes: [], edges: [] };
      }
      if (!Array.isArray(def.nodes)) def.nodes = [];
      if (!Array.isArray(def.edges)) def.edges = [];
      const tpl = this.templates.find((t) => t.id === templateId);
      const baseName = tpl?.name ? tpl.name.toLowerCase().replace(/[^a-z0-9]+/g, '-') : `node-${templateId}`;
      const used = new Set(def.nodes.map((n) => n.id));
      let nodeId = baseName;
      let i = 1;
      while (used.has(nodeId)) {
        i += 1;
        nodeId = `${baseName}-${i}`;
      }
      def.nodes.push({ id: nodeId, template_id: templateId });
      this.item.definition = JSON.stringify(def, null, 2);
    },
  },
};
</script>
